import store from '../store';
import Items from '../views/inventories/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/inventories',
		name: 'inventories',
		component: Items,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
